import type { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import type { AuthService } from '../../../auth/services/auth.service';

export class AuthInterceptor {
  private excludedPaths: string[] = [
    '/auth/login',
    '/auth/register',
    '/auth/verify-otp',
    '/sessions/query'
  ];

  constructor(private authService: AuthService) { }

  /**
   * Setup interceptors for an axios instance
   */
  setupInterceptors(axiosInstance: AxiosInstance): void {
    // console.log(`setup auth interceptor for api: ${axiosInstance}`)
    // Request interceptor - inject JWT token
    axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => this.onRequest(config),
      // (error) => this.onRequestError(error)
    );

    // Response interceptor - handle auth errors
    axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => this.onResponse(response),
      // (error: AxiosError) => this.onResponseError(error)
    );
  }

  /**
   * Request interceptor handler
   */
  private onRequest(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    // Skip auth injection for excluded paths
    if (this.shouldExcludeAuth(config.url || '')) {
      return config;
    }

    // Inject Bearer token if user is authenticated
    // if (this.authService.isAuthenticated && this.authService.authInfos) {
    if (this.authService.isAuthenticated && this.authService.authInfos) {
      const token = this.getTokenFromStorage();

      if (token) {
        // console.info('set bearer');
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    // console.info('no bearer');
    return config;
  }

  /**
   * Request error handler
   */
  // private onRequestError(error: any): Promise<any> {
  //   console.error('Request interceptor error:', error);
  //   return Promise.reject(error);
  // }

  /**
   * Response success handler
   */
  private onResponse(response: AxiosResponse): AxiosResponse {
    return response;
  }

  /**
   * Response error handler
   */
  // private async onResponseError(error: AxiosError): Promise<any> {
  //   const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

  //   // Handle 401 Unauthorized
  //   if (error.response?.status === 401) {
  //     // Prevent infinite retry loop
  //     if (originalRequest._retry) {
  //       this.authService.logout();
  //       return Promise.reject(error);
  //     }

  //     originalRequest._retry = true;

  //     // try {
  //       // Try to refresh token or re-authenticate
  //       // const isStillAuth = await this.authService.checkAuth();

  //     //   if (isStillAuth && originalRequest.headers) {
  //     //     const token = this.getTokenFromStorage();
  //     //     if (token) {
  //     //       originalRequest.headers.Authorization = `Bearer ${token}`;
  //     //       // Retry the original request with new token
  //     //       return axios.request(originalRequest);
  //     //     }
  //     //   }
  //     // } catch (refreshError) {
  //     //   console.error('Token refresh failed:', refreshError);
  //     // }

  //     // If refresh fails, logout user
  //     // this.authService.logout();
  //   }

  //   // Handle 403 Forbidden
  //   // if (error.response?.status === 403) {
  //   //   console.warn('Access forbidden - insufficient permissions');
  //   //   // Optionally redirect to access denied page
  //   // }

  //   return Promise.reject(error);
  // }

  /**
   * Check if path should be excluded from auth injection
   */
  private shouldExcludeAuth(url: string): boolean {
    return this.excludedPaths.some(path => url.includes(path));
  }

  /**
   * Get token from localStorage (fallback)
   */
  private getTokenFromStorage(): string | null {
    return localStorage.getItem(this.authService.TBWJF);
  }

  /**
   * Add paths to exclude from auth injection
   */
  public excludePaths(...paths: string[]): void {
    this.excludedPaths.push(...paths);
  }

  /**
   * Remove interceptors from axios instance
   */
  public removeInterceptors(axiosInstance: AxiosInstance): void {
    axiosInstance.interceptors.request.clear();
    axiosInstance.interceptors.response.clear();
  }
}